module.exports = __webpack_public_path__ + "static/media/proposal_verification_audio.a960f3e4.mp3";